import React from 'react';

import BetfairAppForm from './components/clientproduct/productForms/betfairApp';
import BetfairWidgetForm from './components/clientproduct/productForms/betfairWidget';
import StandingsForm from './components/clientproduct/productForms/standingsApp';
import KouponiForm from './components/clientproduct/productForms/kouponiApp';
import { literals } from './languages';

export const flagsCdn = 'https://wbsearthcomps-5c24.kxcdn.com/svg/4x3/';
export const flagsExt = '.svg';

export const clientCssHost = 'https://www.betwidgets.com:2087/'; 


export const productSettings = {
  '/api/products/1': { 
    form: props =>  <BetfairAppForm {...props} />
  },
  '/api/products/2': { 
    form: props =>  <BetfairWidgetForm {...props} />
  },
  '/api/products/3': { 
    form: props =>  <StandingsForm {...props} />
  },
  '/api/products/4': { 
    form: props =>  <KouponiForm {...props} />
  }
}


export function kouponiAppStyleFields (locale='en') {
  return {
    colors: [
      {
        title: `${literals.bgColor[locale]} 1:`,
        value:'style#background-color#@odd-cell@',
        defaultValue: '#ffc'
      },
      {
        title: `${literals.textColor[locale]} 1:`,
        value:'style#color#@odd-cell@',
        defaultValue: '#333'
      },
      {
        title: `${literals.bgColor[locale]} 2:`,
        value:'style#background-color#@team-cell@',
        defaultValue: '#e9f4e9'
      },
      {
        title: `${literals.textColor[locale]} 2:`,
        value:'style#color#@team-cell@',
        defaultValue: '#333'
      },
      {
        title: `${literals.bgColor[locale]} 2:`,
        value:'style#background-color#@time-cell @',
        defaultValue: '#fff'
      },
      {
        title: `${literals.textColor[locale]} 2:`,
        value:'style#color#@time-cell@',
        defaultValue: '#333'
      },
      {
        title: `${literals.bgColor[locale]} 2:`,
        value:'style#background-color#@opap-code-cell@',
        defaultValue: '#d1e8d1'
      },
      {
        title: `${literals.textColor[locale]} 2:`,
        value:'style#color#@opap-code-cell@',
        defaultValue: '#333'
      },
      {
        title: `${literals.bgColor[locale]} 2:`,
        value:'style#background-color#@general-cell@',
        defaultValue: '#e9f4e9'
      },
      {
        title: `${literals.textColor[locale]} 2:`,
        value:'style#color#@general-cell@',
        defaultValue: '#333'
      },
      // COLOR for green navigation Header
      // {
      //   title: `${literals.bgColor[locale]} 2:`,
      //   value:'style#background-color#@date_header@',
      //   defaultValue: '#20ad15'
      // },
      // {
      //   title: `${literals.textColor[locale]} 2:`,
      //   value:'style#color#@date_header@',
      //   defaultValue: '#fff'
      // },
    ],
    font: {
      title: literals.fontFamily[locale],
      value:'style#font-family#@r_kouponi-container@',
      defaultValue: 'Open Sans'
    }
  }
}

export function betfairAppStyleFields (locale='en') {
  return {
    colors: [
      {
        title: `${literals.bgColor[locale]} 1:`,
        value:'style#background-color#@darkblue-bg@',
        defaultValue: '#214b5e'
      },
      {
        title: `${literals.textColor[locale]} 1:`,
        value:'style#color#@darkblue-bg@',
        defaultValue: '#ffffff'
      },
      {
        title: `${literals.bgColor[locale]} 2:`,
        value:'style#background-color#@bluegray-bg@',
        defaultValue: '#b4d4e3'
      },
      {
        title: `${literals.textColor[locale]} 2:`,
        value:'style#color#@bluegray-bg@',
        defaultValue: '#214b5e'
      },
      {
        title: `${literals.bgColor[locale]} 3:`,
        value:'style#background-color#@gray-bg@',
        defaultValue: '#f2f2f2'
      },
      {
        title: `${literals.textColor[locale]} 3:`,
        value:'style#color#@gray-bg@',
        defaultValue: '#214b5e'
      },
      {
        title: `${literals.bgColor[locale]} 4:`,
        value:'style#background-color#@bluelight-bg@',
        defaultValue: '#2699be'
      },
      {
        title: `${literals.textColor[locale]} 4:`,
        value:'style#color#@bluelight-bg@',
        defaultValue: '#ffffff'
      }
    ],
    font: {
      title: literals.fontFamily[locale],
      value:'style#font-family#@tziroi-table@',
      defaultValue: 'Open Sans'
    }
  }
}

export function standingsAppStyleFields(locale='en') {
  return {
    colors: [
      {
        title: literals.headerBgColor[locale],
        value:'style#background-color#@standings-table-header@',
        defaultValue: '#14405e'
      },
      {
        title: literals.headerMainColor[locale],
        value:'style#color#@standings-table-header@',
        defaultValue: '#fff'
      },
      {
        title: literals.headerSecondaryColor[locale],
        value:'style#color#@standings-table-header-subtitle@',
        defaultValue: '#a5a5a5'
      },
      {
        title: literals.columnTitleColor[locale],
        value:'style#color#@generic-standings-table-header-cell@',
        defaultValue: '#777'
      },
      {
        title: literals.columnTitleBgColor[locale],
        value:'style#background-color#@generic-standings-table-header-cell@',
        defaultValue: '#e4e3e3'
      },
      {
        title: literals.columnTitleVerticalBorderColor[locale],
        value:'style#border-color#@generic-standings-table-header-cell@',
        defaultValue: '#eee'
      },
      {
        title: literals.columnTitleHorizontalBorderColor[locale],
        value:'style#border-color#@standings-app-container thead>tr@',
        defaultValue: '#eee'
      },
      {
        title: literals.tableCellColor[locale],
        value:'style#color#@generic-standings-table-body-cell@',
        defaultValue: '#333'
      },
      {
        title: literals.tableCellVerticalBorderColor[locale],
        value:'style#border-color#@generic-standings-table-body-cell@',
        defaultValue: '#eee'
      },
      {
        title: literals.tableCellHorizontalBorderColor[locale],
        value:'style#border-color#@standings-app-container tbody tr@',
        defaultValue: '#eee'
      },
    ],
    font: {
      title: literals.fontFamily[locale],
      value:'style#font-family#@standings-app-container@',
      defaultValue: 'Open Sans'
    }
  }
  
}


// WEBPACK FOOTER //
// ./src/constants.js